import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9291BDB1-CE57-4802-8CD2-7AD2ED9D9959
 * name glass-cocktail
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-cocktail.svg
 * tags
 * - Food / Drink 
 */
export const GlassCocktailIcon = createSvgIcon(<><path d="M7.5,7L5.5,5H18.5L16.5,7M11,13V19H6V21H18V19H13V13L21,5V3H3V5L11,13Z" /></>, 'GlassCocktailIcon');
export default GlassCocktailIcon